<script>
export default {
  name: 'CandidateListSkeleton',
  props: {
    count: {
      type: Number,
      default: 9,
    },
  },
}
</script>

<template>
  <v-row>
    <v-col
      v-for="index in count"
      :key="`candidate-skeleton-${index}`"
      cols="12"
      sm="6"
      md="4"
    >
      <v-skeleton-loader
        loading
        type="list-item-avatar-three-line"
        class="candidate-skeleton custom-elevation"
      ></v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
::v-deep.candidate-skeleton.v-skeleton-loader--is-loading {
  border-radius: 24px;

  .v-skeleton-loader__avatar {
    width: 90px;
    height: 90px;
    border-radius: 8px;
  }

  .v-skeleton-loader__text {
    height: 1rem;
  }

  .v-skeleton-loader__list-item-avatar-three-line {
    height: 100%;
    padding: 16px;
  }
}
</style>
